import { render, staticRenderFns } from "./MerchantPromo.vue?vue&type=template&id=25465a0a"
import script from "./MerchantPromo.vue?vue&type=script&lang=js"
export * from "./MerchantPromo.vue?vue&type=script&lang=js"
import style0 from "./MerchantPromo.vue?vue&type=style&index=0&id=25465a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports